import { _getAuthInfo, _getUserInfo } from '@/services/user';
import { useCallback, useEffect, useState } from 'react';
export default () => {
  const [userInfo, setUserInfo] = useState<User.IUserInfo>();
  const [authInfo, setAuthInfo] = useState<string[]>([]);

  const getUserInfo = useCallback(() => {
    _getUserInfo().then((d) => d && setUserInfo(d));
  }, []);
  const isSigned = userInfo ? true : false;
  useEffect(() => {
    if (isSigned) {
      _getAuthInfo().then((d) => d && setAuthInfo(d));
    }
  }, [isSigned]);

  return {
    authInfo,
    userInfo,
    getUserInfo,
    isSigned
  };
};
